<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-ensino-medio')" class="main bg-white" id="about-main">
      <b-container id="center-y">
        <b-card class="w-100 p-2 bg-transparent border-0 mb-5 mb-md-0">
          <b-row>
            <b-col cols="12" md="4" lg="3" v-for="(list, index) in lists" :key="index">
              <router-link
                :to="{
                  name: 'render-conteudo-exclusivo',
                  params: { paramsForUrl: list.LinkFree },
                  query: { material: formatParam(list.description) },
                }"
              >
                <b-card
                  :img-src="list.src"
                  img-top
                  img-alt="Imagem de Capa do Material Experimentando Infantil 2 Maternal I"
                  class="mb-3"
                >
                  <h6 class="text-center two-colors">{{ list.title }}</h6>
                  <p class="text-center mt-2">{{ list.description }}</p>
                  <hr />
                  <p class="text-center">{{ list.journal }}</p>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>  
export default {
  data() {
    return {
      pageTitle: 'ENSINO MÉDIO',
      pageSubtitle: 'AULAS DIGITAIS - FÍSICA',
      NamePermission: '',
      IndexPermission: '',
      lists: [],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },
  },
};
</script>

 <style scoped> 
.main {
  margin-top: 30px;
}

.card_sistemacpv {
    border-radius: 8px;
    color: #3A1C53;
}
</style>